import Link from 'next/link'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faCircleCheck } from '@fortawesome/free-solid-svg-icons'
import { Tooltip } from '~/components/Tooltip'
import { Athlete } from '~/domain/Athlete'
import { Benefits } from '~/domain/Benefits'
import linkStyles from '~/components/Link/index.module.scss'
import styles from './index.module.scss'

interface NftBenefitsProps {
  benefits: Benefits
  athlete?: Athlete
}

export const NftBenefits: React.FC<NftBenefitsProps> = ({ benefits, athlete }) => {
  const localeOptions: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }
  const localDate = new Date(benefits.deadline * 1000).toLocaleString(undefined, localeOptions)

  return (
    <div className={ styles['benefits'] }>
      <div className={ styles['benefits__container'] }>
        <div className={ styles['benefits__header'] }>
          <p className={ styles['benefits__subtitle'] }>
            {
              athlete &&
                <>
                  { athlete.name }

                  <FontAwesomeIcon
                    className={ styles['benefits__icon'] }
                    icon={ faCircleCheck }
                    data-tooltip-id="verified-athlete"
                    data-tooltip-content="Verified athlete"
                  />

                  <Tooltip id="verified-athlete" />
                </>
            }

            {
              !athlete &&
                <>
                  Verified Athlete

                  <FontAwesomeIcon
                    className={ styles['benefits__icon'] }
                    icon={ faCircleCheck }
                  />
                </>
            }
          </p>

          <p className={ styles['benefits__title'] }>
            Benefits &amp; Rewards
          </p>

          {
            athlete && athlete.museumUrl &&
              <Link
                href={ athlete.museumUrl }
                target="_blank"
                className={ `${styles['benefits__link']} ${linkStyles['link']}` }
              >
                Visit Athlete&apos;s Museum { }

                <FontAwesomeIcon
                  icon={ faArrowRight }
                />
              </Link>
          }
        </div>

        <div className={ styles['benefits__description'] }>
          <pre className={ styles['benefits__description__text'] }>
            { benefits.description }
          </pre>

          <p className={ styles['benefits__description__date'] }>
            Who can enjoy benefits? NFT owners at { localDate }
          </p>
        </div>
      </div>
    </div>
  )
}
